import request from './request';

export function getExamInfo(hospId, idCard) {
    return request.get('/api/exam/getExamInfo', {
        params: {
            hospid: hospId,
        }
    });
}